"use client";

import { ld } from "@/lib/theme/light-dark";
import { cn } from "@v1/ui/utils";
import { useTranslations } from "next-intl";
import type { CSSProperties, ReactElement } from "react";
import { openConsentBanner, useConsentState } from "./consent-store";

export type CookieSettingsLinkVariant = "marketing" | "careers" | "privacy";

/** Borrows each footer's own link class so it sits flush next to Impressum. */
const VARIANT_CLASS: Record<CookieSettingsLinkVariant, string> = {
  marketing: "mkhero-footlink",
  careers: "dvf-footer-button",
  privacy: "hvcc-settings-link--privacy",
};

const MARKETING_STYLE: CSSProperties = {
  fontSize: 12.5,
  color: ld("rgba(11,15,25,0.5)", "rgba(250,250,250,0.5)"),
};

/** Reopens the banner (withdrawal). Hidden where no banner is mounted, e.g. login. */
export function CookieSettingsLink({
  variant,
}: {
  readonly variant: CookieSettingsLinkVariant;
}): ReactElement | null {
  const t = useTranslations("public.cookieConsent");
  const { active } = useConsentState();
  if (!active) return null;
  return (
    <button
      type="button"
      className={cn("hvcc-settings-link", VARIANT_CLASS[variant])}
      style={variant === "marketing" ? MARKETING_STYLE : undefined}
      onClick={openConsentBanner}
    >
      {t("settingsLink")}
    </button>
  );
}
